import { useEffect, useCallback } from 'react';
import importService from '../services/importService';

// Hook for auto-syncing import status on page load
const useImportSync = () => {
  // Check if there are any running imports
  const checkRunningImports = useCallback(async () => {
    try {
      const hasRunning = await importService.hasRunningImports();
      if (hasRunning) {
        console.log('🔄 Import sync: Running imports detected');
        // You can add additional logic here like showing notifications
        // or updating global state if needed
      }
    } catch (error) {
      console.error('❌ Import sync error:', error);
    }
  }, []);

  // Auto-sync on component mount (page load)
  useEffect(() => {
    checkRunningImports();
  }, [checkRunningImports]);

  // Optional: Set up periodic checking if needed
  useEffect(() => {
    const interval = setInterval(checkRunningImports, 30000); // Check every 30 seconds
    return () => clearInterval(interval);
  }, [checkRunningImports]);

  return {
    checkRunningImports
  };
};

export default useImportSync;
